module.exports = __webpack_public_path__ + "img/MARKS.f92f524a.svg";